import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface BannerServiceProps {
    type: string;
    title: string;
    description: string;
    Image: ReactNode;
    linkTo: string;
    isResonsive?: boolean;
}

const BannerService = ({ type, title, description, Image, linkTo, isResonsive = false }: BannerServiceProps) => {
    // 디바이스 width 1200px 이하
    if (isResonsive) {
        return (
            <Link
                to={linkTo}
                className={`${type === "air" ? "hover:bg-air" : type === "morning" ? "hover:bg-morning" : type === "quick" ? "hover:bg-quick" : "hover:bg-express"} cursor-pointer bg-white flex flex-col items-center rounded-[20px] text-center py-[20px]`}
            >
                <div className="bg-[#f8f8f8] w-[100px] h-[100px] mb-[10px] rounded-full flex items-center justify-center">
                    <div className="">{Image}</div>
                </div>
                <h2 className="text-[17px] font-[500]">{title}</h2>
            </Link>
        );
    }
    // 디바이스 width 1201px 이상
    return (
        <Link
            to={linkTo}
            className={`${type === "air" ? "hover:bg-air" : type === "morning" ? "hover:bg-morning" : type === "quick" ? "hover:bg-quick" : "hover:bg-express"} cursor-pointer bg-white flex flex-col items-center rounded-[20px] text-center w-[285px] h-[430px]`}
        >
            <div className="bg-[#f8f8f8] w-[180px] h-[180px] mt-[60px] mb-9 rounded-full flex items-center justify-center">
                <div className="mb-4">{Image}</div>
            </div>
            <h2 className="text-[27px] font-bold text-[#333] mb-2">{title}</h2>
            <p className="text-[15px] text-[#666]" dangerouslySetInnerHTML={{ __html: description }}></p>
        </Link>
    );
};

export default BannerService;
